import {
    StatusCheckinEnum,
    StatusCheckinEnumLabel,
} from "../model/Enums/StatusCheckinEnum";

export const isAvailableIcon = (status: StatusCheckinEnum) => {
    return (
        StatusCheckinEnum.Compensado === status ||
        StatusCheckinEnum.Dispensado === status ||
        StatusCheckinEnum.PendenciaJustificativa === status ||
        StatusCheckinEnum.AbonoAnalise === status ||
        StatusCheckinEnum.CheckinJustificado === status ||
        StatusCheckinEnum.CheckinRealizado === status ||
        StatusCheckinEnum.DesabilitadoInterjornada === status ||
        StatusCheckinEnum.AbonoLegal === status ||
        StatusCheckinEnum.AbonoAdministrativo === status ||
        StatusCheckinEnum.Recesso === status ||
        StatusCheckinEnum.FeriadoMunicipal === status ||
        StatusCheckinEnum.FeriadoNacional === status ||
        StatusCheckinEnum.Ferias === status ||
        StatusCheckinEnum.LicencaRemunerada === status ||
        StatusCheckinEnum.LicencaNaoRemunerada === status ||
        StatusCheckinEnum.IndeferidoPeloCordenador === status ||
        StatusCheckinEnum.IndeferidoPelaAdministracao === status ||
        StatusCheckinEnum.DeferidoPeloCordenador === status ||
        StatusCheckinEnum.DeferidoPelaAdministracao === status ||
        StatusCheckinEnum.Ausencia === status ||
        StatusCheckinEnum.AusenciaJustificada === status
    );
};

export const getEnumByLabel = (label: string): StatusCheckinEnum => {
    let result: StatusCheckinEnum = StatusCheckinEnum.AguardandoCheckin;

    StatusCheckinEnumLabel.forEach((enumLabel, enumValue) => {
        if (enumLabel === label) {
            result = enumValue;
        }
    });

    return result;
};

export const isCampusHoliday = (StatusCheckin: StatusCheckinEnum) => {
    return (
        StatusCheckinEnum.FeriadoMunicipal === StatusCheckin ||
        StatusCheckinEnum.Recesso === StatusCheckin
    );
};

export const isNationalHoliday = (StatusCheckin: StatusCheckinEnum) => {
    return StatusCheckinEnum.FeriadoNacional === StatusCheckin;
};

export const isAbono = (StatusCheckin: StatusCheckinEnum) => {
    return StatusCheckinEnum.AbonoAdministrativo === StatusCheckin;
};
